interface RewardProgressBarProps {
  /** Progress percentage from 0 to 100 */
  progress: number;
  className?: string;
}

export const RewardProgressBar = ({
  progress,
  className = "",
}: RewardProgressBarProps) => {
  const clampedProgress = Math.min(Math.max(progress, 0), 100);

  return (
    <div
      className={`relative h-2 w-full overflow-hidden rounded-lg bg-brand-color/20 shadow-[0px_2px_10px_0px_rgba(0,0,0,0.06)] ${className}`}
    >
      <div
        className="absolute bottom-0 left-0 top-0 rounded-lg transition-all duration-1000 ease-out"
        style={{
          width: `${clampedProgress}%`,
          backgroundImage:
            "linear-gradient(to right, rgb(var(--repeatmd-brand-color, 29, 27, 167)), rgb(var(--repeatmd-brand-tint, 35, 95, 215)))",
        }}
      />
    </div>
  );
};
